import React, { useRef } from 'react';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import BannerSlider from './Home/Slider';
import CreateOwnDiamond from './Home/CreateOwnDiamond';
import ServiceOffered from './Home/ServiceOffered';
import OurCollection from './Home/OurCollection';
import { ShopDiamondShape } from './Home/ShopDiamondShape';
import WhatPeopleSay from './Home/WhatPeopleSay';
import { InstagramFeed } from './Home/InstagramFeed';
import { Newsletter } from './Home/Newsletter';
import BestSellingProduct from './Home/BestSellingProduct';
import { ExploreCollection } from './Home/ExploreCollection';
// import HappyCustomer from './Home/HappyCustomer';
import Reviews from './Home/Reviews';
import Consult from './Home/Consult';
import { HomeLogoSlider } from './Home/HomeLogoSlider';
// import { Theme } from '../../../../../Helpers/request';

// if(Theme === 'newyork'){
//   require(`../assets/css/newyork.css`);
// }

const NewYorkHome = () => {
   const newsletterRef = useRef(null);

  return (
    <div className='newyork-home'>
      <BannerSlider newsletterRef={newsletterRef} />
      <HomeLogoSlider />
      <CreateOwnDiamond />
      <ShopDiamondShape />
      <ExploreCollection />
      <ServiceOffered />
      <Consult />
      {/* <OurCollection /> */}
      {/* <BestSellingProduct /> */}
      {/* <WhatPeopleSay /> */}
      {/* <HappyCustomer /> */}
      <Reviews />
       <div ref={newsletterRef}>
        <Newsletter />
      </div>
      {/* <Newsletter /> */}
      {/* <InstagramFeed /> */}
    </div>
  )
}

export default NewYorkHome;